module.exports = __webpack_public_path__ + "static/media/service-window-sku-2.b9f0be4a.png";